import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor to handle FormData and auth token
api.interceptors.request.use((config) => {
  // If data is FormData, remove Content-Type header to let browser set it with boundary
  if (config.data instanceof FormData) {
    // Remove Content-Type from all possible locations
    if (config.headers) {
      delete config.headers['Content-Type'];
      if (config.headers.common) {
        delete config.headers.common['Content-Type'];
      }
    }
    // Let browser set Content-Type with boundary automatically
  }
  
  // Add auth token to requests
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Admin API
export const adminAPI = {
  login: (username, password) =>
    api.post('/api/admin/login', { username, password }),
  
  createAdmin: (username, password) =>
    api.post('/api/admin/create-admin', { username, password }),
  
  getCategories: () => api.get('/api/admin/categories'),
  createCategory: (data) => api.post('/api/admin/categories', data),
  updateCategory: (id, data) => api.put(`/api/admin/categories/${id}`, data),
  deleteCategory: (id) => api.delete(`/api/admin/categories/${id}`),
  
  getQuestions: (categoryId) => {
    const params = categoryId ? { category_id: categoryId } : {};
    return api.get('/api/admin/questions', { params });
  },
  createQuestion: (formData) => {
    // FormData handling is done in the interceptor
    // It will automatically remove Content-Type header so browser can set it with boundary
    return api.post('/api/admin/questions', formData);
  },
  updateQuestion: (id, data) => api.put(`/api/admin/questions/${id}`, data),
  deleteQuestion: (id) => api.delete(`/api/admin/questions/${id}`),
  
  getSessions: () => api.get('/api/admin/sessions'),
  createSession: () => api.post('/api/admin/sessions'),
  getSession: (id) => api.get(`/api/admin/sessions/${id}`),
  deleteSession: (id) => api.delete(`/api/admin/sessions/${id}`),
  startSession: (id) => api.post(`/api/admin/sessions/${id}/start`),
  nextQuestion: (id, questionId) => {
    const config = {};
    if (questionId !== null && questionId !== undefined) {
      config.params = { question_id: questionId };
    }
    // Send empty object as body instead of null
    return api.post(`/api/admin/sessions/${id}/next-question`, {}, config);
  },
  getParticipants: (sessionId) => api.get(`/api/admin/sessions/${sessionId}/participants`),
  getStandings: (sessionId, categoryId) => {
    const params = categoryId ? { category_id: categoryId } : {};
    return api.get(`/api/admin/sessions/${sessionId}/standings`, { params });
  },
  finishQuiz: (id) => api.post(`/api/admin/sessions/${id}/finish`),
};

// Participant API
export const participantAPI = {
  register: (sessionCode, name) =>
    api.post(`/api/participant/sessions/${sessionCode}/register`, { name }),
  
  getSessionStatus: (sessionCode) =>
    api.get(`/api/participant/sessions/${sessionCode}/status`),
  
  getSessionParticipants: (sessionCode) =>
    api.get(`/api/participant/sessions/${sessionCode}/participants`),
  
  getCurrentQuestion: (sessionCode) =>
    api.get(`/api/participant/sessions/${sessionCode}/question`),
  
  submitAnswer: (participantId, questionId, answerText) =>
    api.post(`/api/participant/participants/${participantId}/answers`, {
      question_id: questionId,
      answer_text: answerText,
    }),
  
  getParticipant: (participantId) =>
    api.get(`/api/participant/participants/${participantId}`),
  
  getStandings: (sessionCode, categoryId) => {
    const params = categoryId ? { category_id: categoryId } : {};
    return api.get(`/api/participant/sessions/${sessionCode}/standings`, { params });
  },
};

export default api;

